import { createContext, type ReactNode, useContext } from 'react';

import type { ErrorReporter } from './reporting';

const ReportingContext = createContext<ErrorReporter | null>(null);

export type ReportingProviderProps = { reporter: ErrorReporter; children: ReactNode };

export const ReportingProvider = ({ reporter, children }: ReportingProviderProps) => (
  <ReportingContext.Provider value={reporter}>{children}</ReportingContext.Provider>
);

/** The app's one error reporter. Error screens use it; modules never do (they throw, screens recover). */
export const useReporter = (): ErrorReporter => {
  const reporter = useContext(ReportingContext);
  if (reporter === null) {
    throw new Error('useReporter must be used inside ReportingProvider');
  }
  return reporter;
};
